import { render, staticRenderFns } from "./HistoryReport.vue?vue&type=template&id=dbcbd038&scoped=true&"
import script from "./HistoryReport.vue?vue&type=script&lang=js&"
export * from "./HistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./HistoryReport.vue?vue&type=style&index=0&id=dbcbd038&prod&lang=scss&scoped=true&"
import style1 from "./HistoryReport.vue?vue&type=style&index=1&id=dbcbd038&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcbd038",
  null
  
)

export default component.exports